import React from 'react';

function Services() {
  return (
    <div className="container mx-auto py-20 px-4">
      <h1 className="text-4xl font-bold text-indigo-700 mb-6">Our Services</h1>
      <ul className="list-disc ml-5 text-lg text-gray-700">
        <li>Home Buying Services</li>
        <li>Real Estate Consultation</li>
        <li>Cash Offers for Homes</li>
        <li>And More...</li>
      </ul>
    </div>
  );
}

export default Services;

